/** Design values for the task schedule card, empty and configured. Consumed only by task.schedule.card.component.less. */
import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const scheduleCardStyleId = 'wb-v2-schedule-card-theme';

export const scheduleCardBridgeStyles = {
  'wb-schedule-card': {
    '--local-schedule-card-radius': tokens.radius.md,
    '--local-schedule-card-border': tokens.color.border.secondary,
    '--local-schedule-card-bg': tokens.color.background.primary,
    '--local-schedule-card-padding': tokens.spacing.lg,
    '--local-schedule-card-gap': tokens.spacing.md,
    '--local-schedule-card-font-family': tokens.font.family.body,

    '--local-schedule-card-head-gap': tokens.spacing.lg,
    // Matches the configured card's first row, so switching states does not change the card's height.
    '--local-schedule-card-head-min-height': '38px',
    '--local-schedule-card-focus-ring': tokens.focusRing.default,
    '--local-schedule-card-icon-size': '20px',
    '--local-schedule-card-icon-color': tokens.color.foreground.quaternary,
    '--local-schedule-card-icon-brand-color': tokens.color.foreground.brandPrimary,

    '--local-schedule-card-title-color': tokens.color.text.primary,
    '--local-schedule-card-title-font-size': tokens.font.size.textSm,
    '--local-schedule-card-title-font-weight': tokens.font.weight.medium,
    '--local-schedule-card-title-configured-font-weight': tokens.font.weight.semibold,
    '--local-schedule-card-title-line-height': tokens.lineHeight.textSm,

    '--local-schedule-card-subtitle-color': tokens.color.text.tertiary,
    '--local-schedule-card-subtitle-font-size': tokens.font.size.textXs,
    '--local-schedule-card-subtitle-line-height': tokens.lineHeight.textXs,

    '--local-schedule-card-row-gap': tokens.spacing.sm,
    '--local-schedule-card-row-label-color': tokens.color.text.tertiary,
    '--local-schedule-card-row-label-font-size': tokens.font.size.textSm,
    '--local-schedule-card-row-label-line-height': tokens.lineHeight.textSm,

    '--local-schedule-card-chip-padding-y': tokens.spacing.xs,
    '--local-schedule-card-chip-padding-x': tokens.spacing.md,
    '--local-schedule-card-chip-radius': tokens.radius.sm,
    '--local-schedule-card-chip-font-size': tokens.font.size.textSm,
    '--local-schedule-card-chip-line-height': tokens.lineHeight.textSm,
    '--local-schedule-card-chip-font-weight': tokens.font.weight.regular,
    '--local-schedule-card-chip-bg': tokens.color.background.primary,
    '--local-schedule-card-chip-border': tokens.color.border.primary,
    '--local-schedule-card-chip-color': tokens.color.text.secondary,
    // The first chip is the next service, tinted so the eye lands on it before the rest of the run.
    '--local-schedule-card-chip-brand-bg': tokens.color.background.brandPrimary,
    '--local-schedule-card-chip-brand-border': tokens.color.border.brand,
    '--local-schedule-card-chip-brand-color': tokens.color.text.brandSecondary,

    '--local-schedule-card-more-color': tokens.color.text.tertiary,
    '--local-schedule-card-more-font-size': tokens.font.size.textSm,
    '--local-schedule-card-more-line-height': tokens.lineHeight.textSm,

    '--local-schedule-card-link-color': tokens.color.text.brandSecondary,
    '--local-schedule-card-link-hover-color': tokens.color.text.brandSecondaryHover,
    '--local-schedule-card-link-font-size': tokens.font.size.textSm,
    '--local-schedule-card-link-line-height': tokens.lineHeight.textSm,
    '--local-schedule-card-link-font-weight': tokens.font.weight.semibold,
    '--local-schedule-card-link-gap': tokens.spacing.lg,
  },
};
